<div class="flex items-center gap-2 custom-form" [formGroup]="form()">
  <mat-form-field
    class="w-[196px]"
    [class.custom-value-border]="
      isCustomMode() &&
      (getCustomValueState('expectedValue') || getCustomValueState('id') || form().get('exclusiveTo')?.value)
    "
  >
    <mat-label>{{ 'shared.expectedKpis.' + form().get('kpi')?.value | translate }}</mat-label>
    <input matInput type="text" formControlName="expectedValue" numberOnly />

    @if (
      isCustomMode() &&
      !isViewMode() &&
      (getCustomValueState('expectedValue') || getCustomValueState('id')) &&
      !form().get('exclusiveTo')?.value
    ) {
      <span matSuffix>
        <button
          mat-icon-button
          type="button"
          class="mat-secondary-transparent-button-color"
          [disabled]="form().disabled"
          (click)="onRevertToGlobalClick('expectedValue')"
        >
          <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
        </button>
      </span>
    }
    <mat-error [control]="form().get('expectedValue')" />
  </mat-form-field>
</div>
